import { OSKIconDefinition } from '../osk-icon.types';

export const oskIconClock: OSKIconDefinition = {
  name: 'clock',
  content: '<circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />'
};
